export default __webpack_public_path__ + "static/media/R.45a1641c.png";